import { classes } from '@theme/constants';
import { HTMLCustomElement } from '@theme/html-custom-element';

class VideoBanner extends HTMLCustomElement {
  connectedCallback() {
    if (super.connectedCallback) super.connectedCallback();

    this.on('click', this.refs.pause, () => {
      if (this.refs.videoElement.refs.video.paused) {
        this.refs.videoElement.refs.video.play();
        return;
      }

      this.refs.videoElement.refs.video.pause();
    });

    this.on('click', this.refs.mute, () => {
      this.refs.videoElement.refs.video.muted = !this.refs.videoElement.refs.video.muted;
    });

    requestAnimationFrame(() => {
      this.on('play', this.refs.videoElement.refs.video, this.setButtonStates.bind(this));
      this.on('pause', this.refs.videoElement.refs.video, this.setButtonStates.bind(this));
      this.on('volumechange', this.refs.videoElement.refs.video, this.setButtonStates.bind(this));

      this.setButtonStates();
    });
  }

  /**
   * Sets the button states.
   */
  setButtonStates() {
    this.refs.pause.classList.toggle(classes.active, this.refs.videoElement.refs.video.paused);
    this.refs.mute.classList.toggle(classes.active, this.refs.videoElement.refs.video.muted);
  }
}

if (!customElements.get('video-banner')) customElements.define('video-banner', VideoBanner);
